import { render, staticRenderFns } from "./clogin.vue?vue&type=template&id=01b66b66&scoped=true&"
import script from "./clogin.vue?vue&type=script&lang=js&"
export * from "./clogin.vue?vue&type=script&lang=js&"
import style0 from "./clogin.vue?vue&type=style&index=0&id=01b66b66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b66b66",
  null
  
)

export default component.exports